module.exports = __webpack_public_path__ + "assets/reg-card-student-2.2e71f858.svg";